/**
 * Protein Snack Shop Homepage Controller
 * Version: 1.0.0
 * Extracted from the production homepage section.
 *
 * Owns homepage UI behavior and forwards commerce events through
 * the existing DH Commerce Framework analytics pipeline.
 */

(function () {
  'use strict';

 function initConciergeEngine() {
    const root = document.querySelector('.pss-concierge');

    if (!root) return;
    if (root.dataset.pssBound === 'true') return;

    root.dataset.pssBound = 'true';

    const state = {
  preference: null,
  category: null,
  format: null
};

    const cards = Array.from(
      root.querySelectorAll('[data-product-card]')
    );

function buildProductCatalog() {
  return cards.map(function (card, productIndex) {
    const packs = Array.from(
      card.querySelectorAll('[data-card-pack]')
    ).map(function (button, packIndex) {
      return {
        slot: packIndex + 1,

        label:
          button.getAttribute('data-pack-label') || '',

        price:
          button.getAttribute('data-pack-price') || '',

        variantId:
          button.getAttribute('data-variant-id') || '',

        market:
          button.getAttribute(
            'data-market-availability'
          ) || 'everyone'
      };
    });

    return {
      index: productIndex + 1,

      title:
        card.dataset.title || '',

image:
  card.querySelector("img")
    ? card.querySelector("img").src
    : "",

      category:
        card.dataset.category || '',

      displayGroup:
  card.dataset.displayGroup || '',

nutrition:
  card.dataset.nutrition || '',

ingredients:
  card.dataset.ingredients || '',

allergens:
  card.dataset.allergens || '',

shippingStorage:
  card.dataset.shippingStorage || '',

highProtein:
  card.dataset.protein === 'true',

      glutenFree:
        card.dataset.glutenFree === 'true',

      lowCarb:
        card.dataset.lowCarb === 'true',

      limited:
        card.dataset.limited === 'true',

      excludeFromAssortment:
        card.dataset.excludeFromAssortment === 'true',
 
      packs: packs
    };
  });
}

function registerProductCatalog() {
  if (
    !window.DHCommerce ||
    !window.DHCommerce.catalog ||
    typeof window.DHCommerce.catalog.registerProducts !==
      'function'
  ) {
    return false;
  }

  window.DHCommerce.catalog.registerProducts(
    buildProductCatalog()
  );

  return true;
}

    const labels = {
      all: 'Show Me Everything',
      protein: 'High Protein',
      'gluten-free': 'Gluten-Free',
      'low-carb': 'Low Carb',
      limited: 'Limited Drops',
      cheesecakes: 'Cheesecakes',
      cookies: 'Quarter-Pound Cookies',
      brownies: 'Brownies',
      blondies: 'Blondies',
      'brownies-blondies': 'Brownies & Blondies',
      'dessert-bars': 'Dessert Bars',
      apples: 'Apples',
      sauces: 'Sauces',
      granola: 'Granola'
};

root
  .querySelectorAll('[data-format-choice]')
  .forEach(function (button) {
    const formatKey =
      button.dataset.formatChoice;

    const formatLabel =
      button.dataset.formatLabel ||
      button.textContent.trim();

    if (formatKey && formatLabel) {
      labels[formatKey] = formatLabel;
    }
  });

    function camel(value) {
      return value.replace(/-([a-z])/g, function (match, letter) {
        return letter.toUpperCase();
      });
    }

    function normalizeCategory(value) {
      if (value === 'brownies' || value === 'blondies') {
        return 'brownies-blondies';
      }

      return value;
    }

    function cardMatchesCategory(cardCategory, selectedCategory) {
      if (!selectedCategory) return true;

      if (selectedCategory === 'brownies-blondies') {
        return (
          cardCategory === 'brownies' ||
          cardCategory === 'blondies'
        );
      }

      return cardCategory === selectedCategory;
    }

    function showStep(stepName) {
      root.querySelectorAll('[data-step]').forEach(function (step) {
        const isActive = step.dataset.step === stepName;

        step.hidden = !isActive;
        step.classList.toggle('is-active', isActive);
      });
    }

    function setSummary(type, value) {
      const summary = root.querySelector(
        '[data-summary="' + type + '"]'
      );

      const target = root.querySelector(
        '[data-summary-' + type + ']'
      );

      if (!summary || !target) return;

      target.textContent = '✓ ' + (labels[value] || value);
      summary.hidden = false;
    }

    function hideSummary(type) {
      const summary = root.querySelector(
        '[data-summary="' + type + '"]'
      );

      if (summary) {
        summary.hidden = true;
      }
    }

    function productMatches(card) {
  const preference = state.preference;
  const category = state.category;
  const format = state.format;

  const preferenceMatches =
    !preference ||
    preference === 'all' ||
    card.dataset[camel(preference)] === 'true';

  const categoryMatches =
    !category ||
    cardMatchesCategory(
      card.dataset.category,
      category
    );

  const formatMatches =
    category !== 'cheesecakes' ||
    !format ||
    card.dataset.displayGroup === format;

  return (
    preferenceMatches &&
    categoryMatches &&
    formatMatches
  );
}

    function getValidCategories() {
      const preference = state.preference;

      const matchingCards = cards.filter(function (card) {
        if (!preference || preference === 'all') {
          return true;
        }

        return card.dataset[camel(preference)] === 'true';
      });

      const categories = matchingCards.map(function (card) {
        return normalizeCategory(card.dataset.category);
      });

      return Array.from(new Set(categories));
    }

function getValidFormats() {
  const preference = state.preference;

  const matchingFormats = cards
    .filter(function (card) {
      if (card.dataset.category !== 'cheesecakes') {
        return false;
      }

      if (
        preference &&
        preference !== 'all' &&
        card.dataset[camel(preference)] !== 'true'
      ) {
        return false;
      }

      return true;
    })
    .map(function (card) {
      return card.dataset.displayGroup || '';
    })
    .filter(function (format) {
      return (
        format &&
        format !== 'standard'
      );
    });

  return Array.from(
    new Set(matchingFormats)
  );
}

function refreshFormatButtons() {
  const validFormats = getValidFormats();

  const formatContainer =
    root.querySelector('[data-format-choices]');

  if (!formatContainer) {
    return validFormats;
  }

  const formatButtons = Array.from(
    formatContainer.querySelectorAll(
      '[data-format-choice]'
    )
  );

  formatButtons.forEach(function (button) {
    const format =
      button.dataset.formatChoice;

    const isValid =
      validFormats.includes(format);

    button.hidden = !isValid;
    button.disabled = !isValid;

    button.classList.toggle(
      'is-disabled',
      !isValid
    );
  });

  formatButtons
    .sort(function (a, b) {
      const orderA =
        Number(a.dataset.formatOrder) || 50;

      const orderB =
        Number(b.dataset.formatOrder) || 50;

      return orderA - orderB;
    })
    .forEach(function (button) {
      formatContainer.appendChild(button);
    });

  if (
    state.format &&
    !validFormats.includes(state.format)
  ) {
    state.format = null;
    hideSummary('format');
  }

  return validFormats;
}

    function refreshCategoryButtons() {
      const validCategories = getValidCategories();

      root
        .querySelectorAll(
          '[data-step="category"] button[data-category-choice]'
        )
        .forEach(function (button) {
          const category = button.dataset.categoryChoice;
          const isValid = validCategories.includes(category);

          button.hidden = !isValid;
          button.disabled = !isValid;
          button.classList.toggle('is-disabled', !isValid);
        });
    }

    function refreshProducts() {
      cards.forEach(function (card) {
        card.hidden = !productMatches(card);
      });
    }

    function scrollCommercePathIntoView(category) {
      let target = null;

      if (category === 'cheesecakes') {
        target = root.querySelector('[data-step="format"]');
      } else if (category) {
        target = root.querySelector('[data-step="product"]');
      } else {
        target = root.querySelector('[data-step="category"]');
      }

      if (!target) {
        target = root;
      }

      function performScroll(behavior) {
        const offset = window.innerWidth <= 749 ? 92 : 132;
        const top = Math.max(
          0,
          target.getBoundingClientRect().top + window.scrollY - offset
        );

        window.scrollTo({
          top: top,
          behavior: behavior
        });
      }

      /*
        Wait for the selected step and filtered product cards to finish
        changing the page height before calculating the final position.
        The later alignment passes prevent images or reveal animations from
        pushing the customer below the intended category heading.
      */
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          performScroll('smooth');
        });
      });

      window.setTimeout(function () {
        performScroll('auto');
      }, 220);

      window.setTimeout(function () {
        performScroll('auto');
      }, 650);
    }

    function openCommercePath(options) {
  const preference =
    options && options.preference
      ? options.preference
      : 'all';

  const category =
    options && options.category
      ? normalizeCategory(options.category)
      : null;

  /*
    Update the concierge first.

    Optional framework integrations must never be allowed
    to stop the customer-facing shopping flow.
  */

  state.preference = preference;
  state.category = category;
  state.format = null;

  setSummary('preference', state.preference);

  if (state.category) {
    setSummary('category', state.category);
  } else {
    hideSummary('category');
  }

  hideSummary('format');

  refreshCategoryButtons();
  refreshProducts();

  if (state.category === 'cheesecakes') {
  refreshFormatButtons();
  showStep('format');
} else if (state.category) {
  showStep('product');
} else {
  showStep('category');
}
  /*
    Reveal any sections that are intentionally hidden
    until the customer begins shopping.
  */

  document
    .querySelectorAll('.dh-commerce-after-start')
    .forEach(function (element) {
      element.classList.add('is-visible');
    });

const editorialGallery = document.querySelector(
  '.pss-home .dh-editorial-gallery'
);

if (editorialGallery) {
  editorialGallery.classList.add('is-collapsed');
}

  /*
    Optional legacy homepage reveal integration.
  */

  if (typeof window.startShoppingJourney === 'function') {
    try {
      window.startShoppingJourney('shopping');
    } catch (error) {
      console.warn(
        '[DH Commerce] Shopping reveal integration failed:',
        error
      );
    }
  }

  /*
    Optional analytics integration.
  */

  if (
    window.DHCommerce &&
    window.DHCommerce.analytics &&
    typeof window.DHCommerce.analytics.track === 'function'
  ) {
    try {
      window.DHCommerce.analytics.track(
        'concierge:preference_selected',
        {
          preference: state.preference,
          shippingTier:
            window.DHCommerce.state &&
            window.DHCommerce.state.shipping
              ? window.DHCommerce.state.shipping.effectiveTier
              : null
        }
      );
    } catch (error) {
      console.warn(
        '[DH Commerce] Concierge analytics failed:',
        error
      );
    }
  }

  scrollCommercePathIntoView(state.category);
}

    /*
      Preference buttons:
      Show Me Everything, High Protein,
      Gluten-Free, Low Carb, Limited Drops
    */

    root
      .querySelectorAll(
        '[data-step="preference"] button[data-preference]'
      )
      .forEach(function (button) {
        button.addEventListener('click', function () {
          openCommercePath({
            preference: button.dataset.preference,
            category: null
          });
        });
      });

    /*
      Category-choice buttons:
      Cheesecakes, Cookies, Brownies & Blondies, etc.
    */

  root
  .querySelectorAll(
    '[data-step="category"] button[data-category-choice]'
  )
  .forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (button.disabled) {
        return;
      }

      state.category = button.dataset.categoryChoice;

      /*
        Update the customer-facing interface first.
      */

      setSummary('category', state.category);
      refreshProducts();

      if (state.category === 'cheesecakes') {
  state.format = null;

  hideSummary('format');
  refreshFormatButtons();
  showStep('format');
} else {
  state.format = null;

  hideSummary('format');
  showStep('product');
}

      /*
        Optional analytics must not interrupt shopping.
      */

      if (
        window.DHCommerce &&
        window.DHCommerce.analytics &&
        typeof window.DHCommerce.analytics.track === 'function'
      ) {
        try {
          window.DHCommerce.analytics.track(
            'concierge:category_selected',
            {
              category: state.category,
              shippingTier:
                window.DHCommerce.state &&
                window.DHCommerce.state.shipping
                  ? window.DHCommerce.state.shipping.effectiveTier
                  : null
            }
          );
        } catch (error) {
          console.warn(
            '[DH Commerce] Category analytics failed:',
            error
          );
        }
      }
    });
  });


/*
  Cheesecake format buttons:
  Individual Bars or 8-Inch Rounds
*/

root
  .querySelectorAll(
    '[data-step="format"] button[data-format-choice]'
  )
  .forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (button.hidden || button.disabled) {
        return;
      }

      state.format =
        button.dataset.formatChoice;

      setSummary(
        'format',
        state.format
      );

      refreshProducts();
      showStep('product');
    });
  });

    /*
      Editorial-gallery category links
    */

    document
      .querySelectorAll('[data-gallery-category]')
      .forEach(function (button) {
        if (button.dataset.galleryBound === 'true') {
          return;
        }

        button.dataset.galleryBound = 'true';

        button.addEventListener('click', function () {
          const selectedCategory =
            button.dataset.galleryCategory;

          if (selectedCategory === 'limited') {
            openCommercePath({
              preference: 'limited',
              category: null
            });

            return;
          }

          openCommercePath({
            preference: 'all',
            category: selectedCategory
          });
        });
      });

    /*
      Change-selection buttons
    */

    root
  .querySelectorAll('[data-change-step]')
  .forEach(function (button) {
    button.addEventListener('click', function () {
      const step = button.dataset.changeStep;

      if (step === 'preference') {
        state.preference = null;
        state.category = null;
        state.format = null;

        hideSummary('preference');
        hideSummary('category');
        hideSummary('format');
      }

      if (step === 'category') {
        state.category = null;
        state.format = null;

        hideSummary('category');
        hideSummary('format');

        refreshCategoryButtons();
      }

      if (step === 'format') {
        state.format = null;

        hideSummary('format');
        refreshProducts();
      }

      showStep(step);
    });
  });

/*
  Regional product-pack availability

  Pack availability is controlled through:
  data-market-availability="everyone"
  data-market-availability="near"

  Safe fallback is "far", so restricted packs remain hidden
  until the shipping tier has positively resolved.
*/

function getEffectiveProductShippingTier() {
  if (
    window.DHCommerce &&
    window.DHCommerce.state &&
    window.DHCommerce.state.shipping &&
    window.DHCommerce.state.shipping.effectiveTier
  ) {
    return String(
      window.DHCommerce.state.shipping.effectiveTier
    ).toLowerCase();
  }

  return 'far';
}

function clearUnavailablePackSelection(card) {
  if (!card) return;

  card
    .querySelectorAll('[data-card-pack]')
    .forEach(function (packButton) {
      packButton.classList.remove('is-selected');
    });

  const priceElement = card.querySelector(
    '[data-card-price]'
  );

  const addButton = card.querySelector(
    '[data-card-add]'
  );

  if (priceElement) {
    priceElement.textContent =
      'Select a size to continue';
  }

  if (addButton) {
    delete addButton.dataset.variantId;

    addButton.disabled = true;
    addButton.classList.remove('is-ready');
    addButton.textContent = 'Select A Size';
  }
}

function refreshProductPackAvailability() {
  const shippingTier =
    getEffectiveProductShippingTier();

  cards.forEach(function (card) {
    const packButtons = Array.from(
      card.querySelectorAll('[data-card-pack]')
    );

    let selectionWasRemoved = false;

    packButtons.forEach(function (button) {
      const marketAvailability = String(
        button.getAttribute(
          'data-market-availability'
        ) || 'everyone'
      ).toLowerCase();

      const isAvailable =
  marketAvailability === 'everyone' ||
  marketAvailability === shippingTier ||
  (
    marketAvailability === 'middle_far' &&
    (
      shippingTier === 'middle' ||
      shippingTier === 'far'
    )
  );

      if (
        !isAvailable &&
        button.classList.contains('is-selected')
      ) {
        selectionWasRemoved = true;
      }

      button.hidden = !isAvailable;
      button.disabled = !isAvailable;

      button.classList.toggle(
        'is-market-unavailable',
        !isAvailable
      );

      button.setAttribute(
        'aria-hidden',
        isAvailable ? 'false' : 'true'
      );

      if (!isAvailable) {
        button.classList.remove('is-selected');
      }
    });

        if (selectionWasRemoved) {
      clearUnavailablePackSelection(card);
    }
  });

  prepareSingleOptionProducts();
}

/*
  Apply margin-protective fallback immediately.

  Near-only options remain hidden until DH Commerce
  positively resolves the customer as Near.
*/

refreshProductPackAvailability();

/*
  Respond when DH Commerce initializes or the shipping
  tier changes, including preview overrides.
*/

document.addEventListener(
  'dhcommerce',
  function (event) {
    const commerceEvent =
      event && event.detail
        ? event.detail
        : null;

    if (!commerceEvent) return;

    if (
      commerceEvent.name ===
        'framework:initialized'
    ) {
      registerProductCatalog();
      refreshProductPackAvailability();
    }

    if (
      commerceEvent.name ===
        'shipping:tier'
    ) {
      refreshProductPackAvailability();
    }
  }
);

    /*
      Product pack-size buttons
    */

    root
      .querySelectorAll('[data-card-pack]')
      .forEach(function (button) {
        button.addEventListener('click', function () {
          const card = button.closest(
            '[data-product-card]'
          );

          if (!card) return;

if (card.dataset.productSelectedTracked !== "true") {
  card.dataset.productSelectedTracked = "true";

  if (
    window.DHCommerce &&
    window.DHCommerce.analytics &&
    typeof window.DHCommerce.analytics.track === "function"
  ) {
    window.DHCommerce.analytics.track(
      "concierge:product_selected",
      {
        product: card.dataset.title || "",
        category: card.dataset.category || "",
        preference: state.preference || "",
        format: state.format || "",
        shippingTier:
          window.DHCommerce.state &&
          window.DHCommerce.state.shipping
            ? window.DHCommerce.state.shipping.effectiveTier
            : null
      }
    );
  }
}

          const addButton = card.querySelector(
            '[data-card-add]'
          );

          if (!addButton) return;

          card
            .querySelectorAll('[data-card-pack]')
            .forEach(function (packButton) {
              packButton.classList.remove('is-selected');
            });

          button.classList.add('is-selected');

          const priceElement = card.querySelector(
            '[data-card-price]'
          );

          const selectedPrice = button.getAttribute(
            'data-pack-price'
          );

          const selectedLabel = button.getAttribute(
            'data-pack-label'
          );

          if (priceElement) {
            if (selectedPrice && selectedLabel) {
              priceElement.textContent =
                'Selected: ' +
                selectedLabel +
                ' — ' +
                selectedPrice;
            } else if (selectedLabel) {
              priceElement.textContent =
                'Selected: ' + selectedLabel;
            } else {
              priceElement.textContent =
                'Select a size to continue';
            }
          }

          addButton.dataset.variantId =
            button.getAttribute('data-variant-id');

          addButton.disabled = false;
          addButton.classList.add('is-ready');
          addButton.textContent = 'Add To Cart';

          if (
  window.DHCommerce &&
  window.DHCommerce.analytics &&
  typeof window.DHCommerce.analytics.track === 'function'
) {
  try {
    window.DHCommerce.analytics.track(
      'concierge:pack_selected',
      {
        product: card.dataset.title || '',
        category: card.dataset.category || '',
        packLabel: selectedLabel || '',
        packPrice: selectedPrice || '',
        variantId:
          button.getAttribute('data-variant-id') || '',
        shippingTier:
          window.DHCommerce.state &&
          window.DHCommerce.state.shipping
            ? window.DHCommerce.state.shipping.effectiveTier
            : null
      }
    );
  } catch (error) {
    console.warn(
      '[DH Commerce] Pack analytics failed:',
      error
    );
  }
}
        });
      });




/*
  Single-option products

  Used for products such as 6-inch and 8-inch
  cheesecakes where the shopper chooses a flavor,
  but there is no second size decision.
*/

function prepareSingleOptionProducts() {
  cards.forEach(function (card) {
    const isLegacyEightInchRound =
      card.dataset.category === 'cheesecakes' &&
      card.dataset.displayGroup === 'round';

    const shouldAutoSelect =
      card.dataset.autoSelectSingle === 'true' ||
      isLegacyEightInchRound;

    if (!shouldAutoSelect) {
      return;
    }

    const allPackButtons = Array.from(
      card.querySelectorAll('[data-card-pack]')
    );

    const availablePackButtons =
      allPackButtons.filter(function (button) {
        return (
          button.getAttribute('data-variant-id') &&
          !button.hidden &&
          !button.disabled
        );
      });

    const packHeading = card.querySelector(
      '.pss-concierge-product__pack-heading'
    );

    const packContainer = card.querySelector(
      '.pss-concierge-product__packs'
    );

    const priceElement = card.querySelector(
      '[data-card-price]'
    );

    const addButton = card.querySelector(
      '[data-card-add]'
    );

    if (availablePackButtons.length !== 1) {
      if (packHeading) {
        packHeading.hidden = false;
      }

      if (packContainer) {
        packContainer.hidden = false;
      }

      return;
    }

    const onlyPackButton =
      availablePackButtons[0];

    const variantId =
      onlyPackButton.getAttribute(
        'data-variant-id'
      );

    const selectedPrice =
      onlyPackButton.getAttribute(
        'data-pack-price'
      );

    if (!addButton || !variantId) {
      return;
    }

    if (packHeading) {
      packHeading.hidden = true;
    }

    if (packContainer) {
      packContainer.hidden = true;
    }

    allPackButtons.forEach(function (button) {
      button.classList.remove('is-selected');
    });

    onlyPackButton.classList.add(
      'is-selected'
    );

    if (priceElement) {
      priceElement.textContent =
        selectedPrice || '';
    }

    addButton.dataset.variantId =
      variantId;

    addButton.disabled = false;
    addButton.classList.add('is-ready');
    addButton.textContent = 'Add To Cart';
  });
}

    /*
      Shopify AJAX Add to Cart
    */

    root
      .querySelectorAll('[data-card-add]')
      .forEach(function (button) {
        button.addEventListener('click', function () {
          if (!button.dataset.variantId) return;

          button.disabled = true;
          button.textContent = 'Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: Number(button.dataset.variantId),
              quantity: 1
            })
          })
            .then(function (response) {
              if (!response.ok) {
                throw new Error('Cart add failed');
              }

              return response.json();
            })
            .then(function (addedItem) {
  button.textContent = '✓ Added To Cart';

  const card = button.closest(
    '[data-product-card]'
  );

  const selectedPack = card
    ? card.querySelector(
        '[data-card-pack].is-selected'
      )
    : null;

  if (
    window.DHCommerce &&
    window.DHCommerce.analytics &&
    typeof window.DHCommerce.analytics.track ===
      'function'
  ) {
    try {
      const analyticsEvent =
        window.DHCommerce.analytics.track(
          'concierge:add_to_cart',
          {
            product: card
              ? card.dataset.title ||
                addedItem.title ||
                ''
              : addedItem.title || '',

            category: card
              ? card.dataset.category || ''
              : '',

            variantId:
              button.dataset.variantId || '',

            packLabel: selectedPack
              ? selectedPack.getAttribute(
                  'data-pack-label'
                ) || ''
              : '',

            packPrice: selectedPack
              ? selectedPack.getAttribute(
                  'data-pack-price'
                ) || ''
              : '',

            shippingTier:
              window.DHCommerce.state &&
              window.DHCommerce.state.shipping
                ? window.DHCommerce.state.shipping
                    .effectiveTier
                : null
          }
        );

      console.log(
        '[DH Commerce] Add-to-cart tracked:',
        analyticsEvent
      );
    } catch (error) {
      console.warn(
        '[DH Commerce] Product-add analytics failed:',
        error
      );
    }
  } else {
    console.warn(
      '[DH Commerce] Analytics unavailable during cart add.'
    );
  }

  window.setTimeout(function () {
    window.location.assign('/cart');
  }, 1200);
})



            .catch(function (error) {
              console.error(
                'Cart add error:',
                error
              );

              button.disabled = false;
              button.textContent = 'Try Again';
            });
        });
      });

    /*
      URL-triggered commerce paths
    */

    function applyUrlOpenTrigger() {
      const params = new URLSearchParams(
        window.location.search
      );

      const limitedDrop = params.get('limiteddrop');
      const category = params.get('category');
      const preference = params.get('preference');

      if (limitedDrop === 'patriot') {
        openCommercePath({
          preference: 'limited',
          category: 'cheesecakes'
        });

        return;
      }

      if (category || preference) {
        openCommercePath({
          preference: preference || 'all',
          category: category || null
        });
      }
    }

    refreshCategoryButtons();
refreshFormatButtons();
refreshProducts();
registerProductCatalog();
applyUrlOpenTrigger();

root
  .querySelectorAll("[data-product-details]")
  .forEach(function (details) {
    const card = details.closest("[data-product-card]");
    const drawer = details.querySelector("[data-detail-drawer]");
    const titleElement = details.querySelector("[data-detail-title]");
    const contentElement = details.querySelector("[data-detail-content]");
    const closeButton = details.querySelector("[data-detail-close]");

    if (!card || !drawer || !titleElement || !contentElement) {
      return;
    }

    const labels = {
      nutrition: "Nutrition Information",
      ingredients: "Ingredients",
      allergens: "Allergen Information",
      "shipping-storage": "Shipping, Storage & Shelf Life"
    };

    const dataKeys = {
      nutrition: "nutrition",
      ingredients: "ingredients",
      allergens: "allergens",
      "shipping-storage": "shippingStorage"
    };

    function closeDrawer() {
      drawer.hidden = true;

      details
        .querySelectorAll("[data-detail-button]")
        .forEach(function (button) {
          button.classList.remove("is-active");
          button.setAttribute("aria-expanded", "false");
        });
    }

    details
      .querySelectorAll("[data-detail-button]")
      .forEach(function (button) {
        button.addEventListener("click", function () {
          const detailType = button.dataset.detailButton;
          const dataKey = dataKeys[detailType];
          const content = dataKey
            ? card.dataset[dataKey] || ""
            : "";

          const isAlreadyOpen =
            !drawer.hidden &&
            button.classList.contains("is-active");

          closeDrawer();

          if (isAlreadyOpen || !content) {
            return;
          }

          titleElement.textContent =
            labels[detailType] || "Product Information";

          contentElement.textContent = content;
          drawer.hidden = false;

          button.classList.add("is-active");
          button.setAttribute("aria-expanded", "true");

          if (
            window.DHCommerce &&
            window.DHCommerce.analytics &&
            typeof window.DHCommerce.analytics.track === "function"
          ) {
            window.DHCommerce.analytics.track(
              "nutrition:opened",
              {
                product: card.dataset.title || "",
                category: card.dataset.category || "",
                detailType: detailType
              }
            );
          }
        });
      });

        if (closeButton) {
      closeButton.addEventListener("click", closeDrawer);
    }
  });


}


document.addEventListener(
  "DOMContentLoaded",
  initConciergeEngine
);

document.addEventListener(
  "shopify:section:load",
  initConciergeEngine
);

initConciergeEngine();

})();

(function (window, document) {
  "use strict";



  const root = document.querySelector(
    ".pss-home"
  );

  if (!root) {
    return;
  }

  const notice = root.querySelector(
    "[data-commerce-notice]"
  );

  if (!notice) {
    return;
  }

  /*
    Prevent duplicate initialization when Shopify reloads
    the section inside the Theme Editor.
  */

  if (notice.dataset.commerceNoticeBound === "true") {
    return;
  }

  notice.dataset.commerceNoticeBound = "true";

  const eyebrowElement = notice.querySelector(
    "[data-commerce-notice-eyebrow]"
  );

  const headlineElement = notice.querySelector(
    "[data-commerce-notice-headline]"
  );

  const messageElement = notice.querySelector(
    "[data-commerce-notice-message]"
  );

  const offerElement = notice.querySelector(
    "[data-commerce-notice-offer]"
  );

  const progressElement = notice.querySelector(
    "[data-commerce-notice-progress]"
  );

  const shippingElement = notice.querySelector(
    "[data-commerce-notice-shipping]"
  );

  const giftElement = notice.querySelector(
    "[data-commerce-notice-gift]"
  );

const shippingAmountElement = notice.querySelector(
  "[data-commerce-notice-shipping-amount]"
);

const giftAmountElement = notice.querySelector(
  "[data-commerce-notice-gift-amount]"
);

const giftLabelElement = notice.querySelector(
  "[data-commerce-notice-gift-label]"
);

const shippingBarElement = notice.querySelector(
  "[data-commerce-notice-shipping-bar]"
);

const giftBarElement = notice.querySelector(
  "[data-commerce-notice-gift-bar]"
);

const shippingFillElement = notice.querySelector(
  "[data-commerce-notice-shipping-fill]"
);

const giftFillElement = notice.querySelector(
  "[data-commerce-notice-gift-fill]"
);

const coachElement = notice.querySelector(
  "[data-commerce-notice-coach]"
);

const coachHeadlineElement = notice.querySelector(
  "[data-commerce-notice-coach-headline]"
);

const coachAdviceElement = notice.querySelector(
  "[data-commerce-notice-coach-advice]"
);

  const dismissButton = notice.querySelector(
    "[data-commerce-notice-dismiss]"
  );

  let frameworkEventsBound = false;
  let cartRefreshTimer = null;
  let activePromotionId = null;

  notice.setAttribute("aria-live", "polite");
  notice.setAttribute("aria-atomic", "true");


  /* ======================================================
     HELPERS
  ====================================================== */

  function getCommerce() {
    return window.DHCommerce || null;
  }

  function getShopifyRoot() {
    return (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    )
      ? window.Shopify.routes.root
      : "/";
  }

  function formatCurrency(value) {
    const amount = Number(value) || 0;

    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits:
        Number.isInteger(amount) ? 0 : 2,
      maximumFractionDigits: 2
    }).format(amount);
  }

function getProgressPercentage(subtotal, threshold) {
  subtotal = Number(subtotal) || 0;
  threshold = Number(threshold) || 0;

  if (threshold <= 0) {
    return 0;
  }

  return Math.min(
    Math.max((subtotal / threshold) * 100, 0),
    100
  );
}

  function getDismissalKey(promotionId) {
    return (
      "dhcommerce_notice_dismissed_" +
      String(promotionId || "unknown")
    );
  }

  function isDismissed(promotionId) {
    try {
      return (
        window.sessionStorage.getItem(
          getDismissalKey(promotionId)
        ) === "true"
      );
    } catch (error) {
      return false;
    }
  }

  function saveDismissal(promotionId) {
    try {
      window.sessionStorage.setItem(
        getDismissalKey(promotionId),
        "true"
      );
    } catch (error) {
      /*
        Session storage may be unavailable in private or
        restricted browser environments. Dismissal still works
        for the remainder of the current page.
      */
    }
  }

  function clearNotice() {
    activePromotionId = null;
    notice.hidden = true;
    notice.classList.remove(
      "is-visible",
      "is-shipping-unlocked",
      "is-gift-unlocked"
    );

    if (progressElement) {
      progressElement.hidden = true;
    }
  }


  /* ======================================================
     PROMOTION RENDERING
  ====================================================== */

  function renderPromotion(promotion) {
    if (!promotion) {
      clearNotice();
      return false;
    }

    activePromotionId = promotion.id;

    if (isDismissed(promotion.id)) {
      notice.hidden = true;
      return false;
    }

    if (eyebrowElement) {
      eyebrowElement.textContent =
        promotion.eyebrow || "";
    }

    if (headlineElement) {
      headlineElement.textContent =
        promotion.headline || "";
    }

    if (messageElement) {
      messageElement.textContent =
        promotion.message || "";
    }

    if (offerElement) {
      offerElement.textContent =
        promotion.offerLabel || "";
    }

    notice.dataset.promotionId =
      promotion.id || "";

    notice.dataset.shippingTier =
      promotion.shippingTier || "";

    notice.hidden = false;
    notice.classList.add("is-visible");

    return true;
  }


  /* ======================================================
     CART EVALUATION RENDERING
  ====================================================== */

  function renderEvaluation(evaluation) {
    if (
      !evaluation ||
      !evaluation.promotion
    ) {
      clearNotice();
      return;
    }

    const promotion = evaluation.promotion;

    const subtotal =
  Number(evaluation.subtotal) || 0;

const shippingThreshold =
  Number(promotion.freeShippingThreshold) || 0;

const giftThreshold =
  Number(promotion.giftThreshold) || 0;

const shippingPercentage =
  getProgressPercentage(
    subtotal,
    shippingThreshold
  );

const giftPercentage =
  getProgressPercentage(
    subtotal,
    giftThreshold
  );

    if (!renderPromotion(promotion)) {
      return;
    }

    notice.classList.toggle(
      "is-shipping-unlocked",
      Boolean(evaluation.freeShippingUnlocked)
    );

    notice.classList.toggle(
      "is-gift-unlocked",
      Boolean(evaluation.giftUnlocked)
    );

    if (shippingElement) {
      shippingElement.textContent =
        evaluation.freeShippingUnlocked
          ? "✓ Free shipping unlocked"
          : "You're " +
            formatCurrency(
              evaluation.amountUntilFreeShipping
            ) +
            " away from free shipping.";
    }

    if (giftElement) {
      const giftName =
        promotion.giftName ||
        "today's gift";

      giftElement.textContent =
        evaluation.giftUnlocked
          ? "✓ " + giftName + " unlocked"
          : "You're " +
            formatCurrency(
              evaluation.amountUntilGift
            ) +
            " away from " +
            giftName +
            ".";
    }

if (shippingAmountElement) {
  shippingAmountElement.textContent =
    formatCurrency(subtotal) +
    " of " +
    formatCurrency(shippingThreshold);
}

if (giftAmountElement) {
  giftAmountElement.textContent =
    formatCurrency(subtotal) +
    " of " +
    formatCurrency(giftThreshold);
}

if (giftLabelElement) {
  giftLabelElement.textContent =
    promotion.giftName ||
    "Promotional Gift";
}

if (shippingFillElement) {
  shippingFillElement.style.width =
    shippingPercentage + "%";
}

if (giftFillElement) {
  giftFillElement.style.width =
    giftPercentage + "%";
}

if (shippingBarElement) {
  shippingBarElement.setAttribute(
    "aria-valuenow",
    String(Math.round(shippingPercentage))
  );
}

if (giftBarElement) {
  giftBarElement.setAttribute(
    "aria-valuenow",
    String(Math.round(giftPercentage))
  );
}

    if (progressElement) {
      progressElement.hidden = false;
    }

    notice.dataset.cartSubtotal =
      String(evaluation.subtotal || 0);
  }

function renderCoachAdvice(advice) {
  if (
    !advice ||
    !advice.headline ||
    !advice.advice
  ) {
    if (coachElement) {
      coachElement.hidden = true;
    }

    return;
  }

  if (coachHeadlineElement) {
    coachHeadlineElement.textContent =
      advice.headline;
  }

  if (coachAdviceElement) {
    coachAdviceElement.textContent =
      advice.advice;
  }

  if (coachElement) {
    coachElement.hidden = false;
  }

  notice.dataset.coachTarget =
    advice.target || "";

  notice.dataset.coachType =
    advice.type || "";
}

  /* ======================================================
     SHOPIFY CART
  ====================================================== */

  async function getCartSubtotal() {
    const response = await fetch(
      getShopifyRoot() + "cart.js",
      {
        method: "GET",
        headers: {
          Accept: "application/json"
        },
        credentials: "same-origin"
      }
    );

    if (!response.ok) {
      throw new Error(
        "Shopify cart could not be loaded."
      );
    }

    const cart = await response.json();

    return (
      Number(cart.total_price) || 0
    ) / 100;
  }

  async function refreshFromCart() {
    const commerce = getCommerce();

    if (
      !commerce ||
      !commerce.promotions ||
      typeof commerce.promotions.getCurrent !==
        "function" ||
      typeof commerce.promotions.evaluateCart !==
        "function"
    ) {
      return;
    }

    const promotion =
      commerce.promotions.getCurrent();

    if (!promotion) {
      clearNotice();
      return;
    }

    renderPromotion(promotion);

    try {
      const subtotal =
        await getCartSubtotal();

      commerce.promotions.evaluateCart(
        subtotal
      );
    } catch (error) {
      /*
        The promotional message can still render even if Shopify's
        cart endpoint temporarily fails. Only progress is hidden.
      */

      console.warn(
        "[DH Commerce] Promotion cart evaluation failed:",
        error
      );

      if (progressElement) {
        progressElement.hidden = true;
      }
    }
  }

  function scheduleCartRefresh(delay) {
    window.clearTimeout(cartRefreshTimer);

    cartRefreshTimer = window.setTimeout(
      refreshFromCart,
      Number(delay) || 120
    );
  }


  /* ======================================================
     FRAMEWORK EVENTS
  ====================================================== */

  function bindFrameworkEvents() {
    const commerce = getCommerce();

    if (
      frameworkEventsBound ||
      !commerce ||
      typeof commerce.on !== "function"
    ) {
      return;
    }

    frameworkEventsBound = true;

    /*
      Promotion Engine has initialized.
    */

    commerce.on(
      "promotion:ready",
      function (event) {
        const promotion =
          event &&
          event.payload
            ? event.payload.promotion
            : null;

        renderPromotion(promotion);
        scheduleCartRefresh(0);
      }
    );

    /*
      Promotion Engine has evaluated the current subtotal.
    */

    commerce.on(
      "promotion:evaluated",
      function (event) {
        renderEvaluation(
          event ? event.payload : null
        );
      }
    );

commerce.on(
  "coach:updated",
  function (event) {
    const advice =
      event &&
      event.payload
        ? event.payload.advice
        : null;

    renderCoachAdvice(advice);
  }
);

    /*
      A preview override or future shipping resolver changed
      the active customer tier.
    */

    commerce.on(
      "shipping:tier",
      function () {
        scheduleCartRefresh(0);
      }
    );

    /*
      A standard Concierge product was added through Shopify AJAX.
    */

    commerce.on(
      "concierge:product_added",
      function () {
        scheduleCartRefresh(180);
      }
    );

    /*
      A completed assortment was added through Shopify AJAX.
    */

    commerce.on(
      "assortment:added_to_cart",
      function () {
        scheduleCartRefresh(180);
      }
    );

    /*
      Covers cases where this module connects after the framework
      has already completed initialization.
    */

    if (
  commerce.coach &&
  typeof commerce.coach.getCurrentAdvice ===
    "function"
) {
  renderCoachAdvice(
    commerce.coach.getCurrentAdvice()
  );
}

scheduleCartRefresh(0);
  }


  /* ======================================================
     DISMISSAL
  ====================================================== */

  if (dismissButton) {
    dismissButton.addEventListener(
      "click",
      function () {
        if (activePromotionId) {
          saveDismissal(activePromotionId);
        }

        notice.hidden = true;
        notice.classList.remove("is-visible");
      }
    );
  }


  /* ======================================================
     BOOTSTRAP
  ====================================================== */

  /*
    The external framework script uses defer, so this homepage
    script may execute before window.DHCommerce is ready.

    Listen to the framework's underlying DOM event immediately.
  */

  document.addEventListener(
    "dhcommerce",
    function (event) {
      const commerceEvent =
        event && event.detail
          ? event.detail
          : null;

      if (
        commerceEvent &&
        commerceEvent.name ===
          "framework:initialized"
      ) {
        bindFrameworkEvents();
      }
    }
  );

  /*
    Also attempt immediate binding in case the framework has
    already initialized.
  */

  bindFrameworkEvents();

})(window, document);

(function () {
  "use strict";

console.log(
  "[DH Commerce] ASSORTMENT SCRIPT TEST 0815"
);

  const homepageRoot = document.querySelector(
    ".pss-home"
  );

  const assortmentRoot = document.querySelector(
    "[data-assortment-root]"
  );

  if (!assortmentRoot) {
    return;
  }

  const DHCommerce = window.DHCommerce = window.DHCommerce || {};
  DHCommerce.state = DHCommerce.state || {};

 /*
====================================================
ASSORTMENT ELEMENT LOOKUPS
====================================================
*/

const assortmentSection = assortmentRoot.querySelector(
  "[data-assortment-section]"
);

const assortmentItems = assortmentRoot.querySelector(
  "[data-assortment-items]"
);

const assortmentCount = assortmentRoot.querySelector(
  "[data-assortment-count]"
);

const assortmentProgress = assortmentRoot.querySelector(
  "[data-assortment-progress]"
);

const assortmentCheckout = assortmentRoot.querySelector(
  "[data-assortment-checkout]"
);

const assortmentGift = assortmentRoot.querySelector(
  "[data-assortment-gift]"
);

/*
  The sticky assortment tracker is a page-level element.
  It may live outside the standalone assortment section,
  so do not scope these lookups to assortmentRoot.
*/

const assortmentTracker = document.querySelector(
  "[data-assortment-tracker]"
);

const assortmentTrackerCount = assortmentTracker
  ? assortmentTracker.querySelector(
      "[data-assortment-tracker-count]"
    )
  : null;

const assortmentTrackerProgress = assortmentTracker
  ? assortmentTracker.querySelector(
      "[data-assortment-tracker-progress]"
    )
  : null;

const assortmentTrackerView = assortmentTracker
  ? assortmentTracker.querySelector(
      "[data-assortment-tracker-view]"
    )
  : null;

const assortmentChooser = assortmentRoot.querySelector(
  "[data-assortment-chooser]"
);

const assortmentChooserOptions = assortmentChooser
  ? Array.from(
      assortmentChooser.querySelectorAll(
        "[data-assortment-option]"
      )
    )
  : [];

const assortmentChooserCloseButtons = assortmentChooser
  ? Array.from(
      assortmentChooser.querySelectorAll(
        "[data-assortment-chooser-close]"
      )
    )
  : [];

const sizeButtons = Array.from(
  assortmentRoot.querySelectorAll(
    ".pss-assortment-size[data-assortment-size]"
  )
);

const addButtons = homepageRoot
  ? Array.from(
      homepageRoot.querySelectorAll(
        "[data-card-assortment]"
      )
    )
  : [];

/*
====================================================
VERIFY EVERYTHING EXISTS
====================================================
*/

console.log("[DH Commerce] Assortment Elements", {
  assortmentSection,
  assortmentItems,
  assortmentCount,
  assortmentProgress,
  assortmentCheckout,
  assortmentChooser,
  assortmentGift,
  assortmentTracker,
  assortmentTrackerCount,
  assortmentTrackerProgress,
  assortmentTrackerView,
  assortmentChooserOptionCount:
    assortmentChooserOptions.length,
  assortmentSizeButtonCount:
    sizeButtons.length,
  assortmentAddButtonCount:
    addButtons.length
});

if (
  !assortmentSection ||
  !assortmentItems ||
  !assortmentCount ||
  !assortmentProgress ||
  !assortmentCheckout ||
  !assortmentChooser
) {
  console.error(
    "[DH Commerce] Assortment initialization FAILED."
  );

  return;
}

/*
  Temporarily remembers the dessert button that caused
  the assortment chooser to open.
*/

let pendingAssortmentButton = null;

function getEffectiveShippingTier() {
  if (
    window.DHCommerce &&
    window.DHCommerce.state &&
    window.DHCommerce.state.shipping &&
    window.DHCommerce.state.shipping.effectiveTier
  ) {
    return window.DHCommerce.state.shipping.effectiveTier;
  }

  /*
    Margin-protective fallback:
    do not expose the Near-only 4-count unless the
    visitor has been positively resolved as Near.
  */

  return "far";
}

function isAssortmentMarketAvailable(market, shippingTier) {
  const normalizedMarket = String(market || "everyone").toLowerCase();
  const normalizedTier = String(shippingTier || "far").toLowerCase();

  return (
    normalizedMarket === "everyone" ||
    normalizedMarket === normalizedTier ||
    (
      normalizedMarket === "middle_far" &&
      (normalizedTier === "middle" || normalizedTier === "far")
    )
  );
}

function refreshAssortmentChooserOptions() {
  const shippingTier = getEffectiveShippingTier();

  assortmentChooserOptions.forEach(function (option) {
    const market =
      option.dataset.assortmentMarket || "everyone";

    const isAvailable =
      isAssortmentMarketAvailable(
        market,
        shippingTier
      );

    option.hidden = !isAvailable;
    option.disabled = !isAvailable;
  });
}

function refreshAssortmentSizeButtons() {
  const shippingTier = getEffectiveShippingTier();

  sizeButtons.forEach(function (button) {
    const market =
      button.dataset.assortmentMarket || "everyone";

    const isAvailable =
      isAssortmentMarketAvailable(
        market,
        shippingTier
      );

    button.hidden = !isAvailable;
    button.disabled = !isAvailable;
  });
}

function openAssortmentChooser(button) {
  pendingAssortmentButton = button;

  refreshAssortmentChooserOptions();
  refreshAssortmentSizeButtons();

  assortmentChooser.hidden = false;
  document.body.classList.add(
    "pss-assortment-chooser-open"
  );

  const firstVisibleOption =
    assortmentChooserOptions.find(function (option) {
      return !option.hidden && !option.disabled;
    });

  if (firstVisibleOption) {
    window.setTimeout(function () {
      firstVisibleOption.focus();
    }, 0);
  }
}

function closeAssortmentChooser() {
  assortmentChooser.hidden = true;

  document.body.classList.remove(
    "pss-assortment-chooser-open"
  );

  if (pendingAssortmentButton) {
    pendingAssortmentButton.focus();
  }

  pendingAssortmentButton = null;
}

assortmentChooserCloseButtons.forEach(function (button) {
  button.addEventListener("click", function () {
    closeAssortmentChooser();
  });
});

document.addEventListener("keydown", function (event) {
  if (
    event.key === "Escape" &&
    !assortmentChooser.hidden
  ) {
    closeAssortmentChooser();
  }
});

  /* ==========================================
     SHOPIFY ASSORTMENT VARIANTS
  ========================================== */

  let assortmentDefinitions = [];

try {
  assortmentDefinitions =
    assortmentChooserOptions
      .map(function (option) {
        return {
          id:
            option.dataset.assortmentId || "",

          size:
            Number(
              option.dataset.assortmentSize
            ) || 0,

          name:
            option.dataset.assortmentName || "",

          variantId:
            String(
              option.dataset.assortmentVariantId ||
              ""
            ).trim(),

          price:
            option.dataset.assortmentPrice || "",

          savingsPercent:
            Number(
              option.dataset.assortmentSavings
            ) || 0,

          badge:
            option.dataset.assortmentBadge || "",

          productLine:
            option.dataset.assortmentProductLine ||
            "",

          market:
            option.dataset.assortmentMarket ||
            "everyone",

          sortOrder:
            Number(
              option.dataset.assortmentSort
            ) || 0,

          isDefault:
            option.dataset.assortmentDefault ===
            "true"
        };
      })
      .filter(function (definition) {
        return (
          definition.size > 0 &&
          definition.variantId
        );
      })
      .sort(function (a, b) {
        return a.sortOrder - b.sortOrder;
      });

} catch (error) {
  console.error(
    "[DH Commerce] ASSORTMENT DEFINITION ERROR:",
    error
  );
}


/*
  Publish all merchant-configured assortment definitions
  to the shared DH Commerce catalog.

  This registers every valid definition, not merely the
  definitions currently visible for the shopper's region.
*/

function registerAssortmentCatalog() {
  console.warn(
  "[DH Commerce] Attempting assortment registration:",
  {
    frameworkAvailable:
      Boolean(window.DHCommerce),

    catalogAvailable:
      Boolean(
        window.DHCommerce &&
        window.DHCommerce.catalog
      ),

    registerMethodAvailable:
      Boolean(
        window.DHCommerce &&
        window.DHCommerce.catalog &&
        typeof window.DHCommerce.catalog
          .registerAssortments === "function"
      ),

    assortmentCount:
      assortmentDefinitions.length
  }
);

  if (
    !window.DHCommerce ||
    !window.DHCommerce.catalog ||
    typeof window.DHCommerce.catalog.registerAssortments !==
      "function"
  ) {
    return false;
  }

  window.DHCommerce.catalog.registerAssortments(
    assortmentDefinitions
  );

  return true;
}

/*
  Attempt immediate registration in case the framework
  finished loading before the assortment builder.
*/



registerAssortmentCatalog();

/*
  Also register when the framework initializes in case
  this homepage module loaded first.
*/

document.addEventListener(
  "dhcommerce",
  function (event) {
    const commerceEvent =
      event && event.detail
        ? event.detail
        : null;

    if (
      commerceEvent &&
      commerceEvent.name ===
        "framework:initialized"
    ) {
      registerAssortmentCatalog();
    }
  }
);

function getAvailableAssortmentDefinitions() {
  const shippingTier =
    getEffectiveShippingTier();

  return assortmentDefinitions.filter(
    function (definition) {
      return isAssortmentMarketAvailable(
        definition.market,
        shippingTier
      );
    }
  );
}

function getAssortmentDefinitionBySize(size) {
  return assortmentDefinitions.find(
    function (definition) {
      return (
        definition.size === Number(size)
      );
    }
  ) || null;
}

function getDefaultAssortmentDefinition() {
  const available =
    getAvailableAssortmentDefinitions();

  return (
    available.find(function (definition) {
      return definition.isDefault;
    }) ||
    available[0] ||
    null
  );
}

 /* ==========================================
   SHARED ASSORTMENT STATE
========================================== */

const existingState =
  DHCommerce.state.assortment &&
  typeof DHCommerce.state.assortment === "object"
    ? DHCommerce.state.assortment
    : {};

const availableInitialDefinitions =
  getAvailableAssortmentDefinitions();

let initialAssortmentDefinition = null;

/*
  Preserve an existing assortment when it still matches
  an assortment available to the shopper.
*/

if (existingState.assortmentId) {
  initialAssortmentDefinition =
    availableInitialDefinitions.find(function (definition) {
      return (
        definition.id ===
        String(existingState.assortmentId)
      );
    }) || null;
}

if (
  !initialAssortmentDefinition &&
  existingState.variantId
) {
  initialAssortmentDefinition =
    availableInitialDefinitions.find(function (definition) {
      return (
        definition.variantId ===
        String(existingState.variantId)
      );
    }) || null;
}

if (
  !initialAssortmentDefinition &&
  existingState.size
) {
  initialAssortmentDefinition =
    availableInitialDefinitions.find(function (definition) {
      return (
        definition.size ===
        Number(existingState.size)
      );
    }) || null;
}

/*
  If no existing assortment is valid, use the configured
  default assortment or the first available assortment.
*/

if (!initialAssortmentDefinition) {
  initialAssortmentDefinition =
    getDefaultAssortmentDefinition();
}

DHCommerce.state.assortment = {
  assortmentId: initialAssortmentDefinition
    ? initialAssortmentDefinition.id
    : "",

  assortmentName: initialAssortmentDefinition
    ? initialAssortmentDefinition.name
    : "",

  size: initialAssortmentDefinition
    ? initialAssortmentDefinition.size
    : 0,

  sizeChosen:
    typeof existingState.sizeChosen === "boolean"
      ? existingState.sizeChosen
      : false,

  variantId: initialAssortmentDefinition
    ? initialAssortmentDefinition.variantId
    : "",

  title: initialAssortmentDefinition
    ? initialAssortmentDefinition.name
    : "",

  price: initialAssortmentDefinition
    ? initialAssortmentDefinition.price
    : "",

  savingsPercent: initialAssortmentDefinition
    ? initialAssortmentDefinition.savingsPercent
    : 0,

  badge: initialAssortmentDefinition
    ? initialAssortmentDefinition.badge
    : "",

  productLine: initialAssortmentDefinition
    ? initialAssortmentDefinition.productLine
    : "",

  market: initialAssortmentDefinition
    ? initialAssortmentDefinition.market
    : "everyone",

  items: Array.isArray(existingState.items)
    ? existingState.items
    : [],

  giftNote: existingState.giftNote || "",

  ready: Boolean(existingState.ready)
};

const state = DHCommerce.state.assortment;

/*
  Existing assortments already have a size selected.
*/

if (state.items.length > 0) {
  state.sizeChosen = true;
}

let readyEventWasSent = state.ready;
let assortmentStarted = state.items.length > 0;
let assortmentBuilderIsVisible = false;


/*
  Hide the compact tracker whenever the full assortment
  builder is visible in the viewport.
*/

if (
  assortmentSection &&
  assortmentTracker &&
  "IntersectionObserver" in window
) {
  const assortmentVisibilityObserver =
    new IntersectionObserver(
      function (entries) {
        const entry = entries[0];

        assortmentBuilderIsVisible =
          Boolean(entry && entry.isIntersecting);

        const usedSelections =
          getUsedSelections();

        assortmentTracker.hidden =
          usedSelections === 0 ||
          assortmentBuilderIsVisible;
      },
      {
        threshold: 0.12
      }
    );

  assortmentVisibilityObserver.observe(
    assortmentSection
  );
}


  /* ==========================================
     HELPERS
  ========================================== */

  function normalizeText(value) {
    return String(value || "").trim();
  }

  function normalizeCategory(value) {
    return normalizeText(value).toLowerCase();
  }

  function getShippingTier() {
    return (
      DHCommerce.state &&
      DHCommerce.state.shipping &&
      DHCommerce.state.shipping.effectiveTier
    ) || "unknown";
  }

  function getUsedSelections() {
    return state.items.reduce(function (total, item) {
      const selections = Number(item.selections) || 1;
      const quantity = Number(item.quantity) || 1;

      return total + (selections * quantity);
    }, 0);
  }

  function getRemainingSelections() {
    return Math.max(state.size - getUsedSelections(), 0);
  }

function refreshAssortmentProductVisibility() {
  const assortmentHasStarted =
  state.items.length > 0;

(homepageRoot || document)
  .querySelectorAll(
    '[data-product-card][data-exclude-from-assortment="true"]'
  )
  .forEach(function (card) {
    /*
      Assortment rules may hide excluded products after an
      assortment begins, but they must never unhide a product
      that the concierge category filter has already hidden.
    */

    if (assortmentHasStarted) {
      card.hidden = true;
    }
  });
}

  function getAssortmentDefinitionById(assortmentId) {
  const normalizedId =
    normalizeText(assortmentId);

  if (!normalizedId) {
    return null;
  }

  return assortmentDefinitions.find(
    function (definition) {
      return definition.id === normalizedId;
    }
  ) || null;
}


function getVariantForSize(size) {
  const definition =
    getAssortmentDefinitionBySize(size);

  return definition
    ? normalizeText(definition.variantId)
    : "";
}

  function createItemKey(category, title) {
    return normalizeCategory(category) + "|" +
      normalizeText(title).toLowerCase();
  }

  function escapeHtml(value) {
    const element = document.createElement("div");
    element.textContent = String(value || "");

    return element.innerHTML;
  }

  function emitEvent(eventName, payload) {
    const location =
  DHCommerce.state &&
  DHCommerce.state.shipping &&
  DHCommerce.state.shipping.location
    ? DHCommerce.state.shipping.location
    : {};

const detail = Object.assign(
  {
    assortmentId:
      state.assortmentId || "",

    assortmentName:
      state.assortmentName ||
      state.title ||
      "",

    assortmentSize:
      Number(state.size) || 0,

    variantId:
      state.variantId || "",

    price:
      state.price || "",

    savingsPercent:
      Number(state.savingsPercent) || 0,

    badge:
      state.badge || "",

    productLine:
      state.productLine || "",

    market:
      state.market || "everyone",

    selectedCount:
      getUsedSelections(),

    remainingCount:
      getRemainingSelections(),

    shippingTier:
      getShippingTier(),

    city:
      location.city || "",

    state:
      location.state || "",

    zip:
      location.zip || ""
  },
  payload || {}
);

    if (
      DHCommerce.analytics &&
      typeof DHCommerce.analytics.track === "function"
    ) {
      try {
        DHCommerce.analytics.track(eventName, detail);
      } catch (error) {
        console.warn(
          "[DH Commerce] Analytics event failed:",
          eventName,
          error
        );
      }
    }



    window.dispatchEvent(
      new CustomEvent("dhcommerce:" + eventName, {
        detail: detail
      })
    );
  }

  function announce(message) {
    let liveRegion = assortmentRoot.querySelector(
      "[data-assortment-live-region]"
    );

    if (!liveRegion) {
      liveRegion = document.createElement("div");
      liveRegion.setAttribute("data-assortment-live-region", "");
      liveRegion.setAttribute("aria-live", "polite");
      liveRegion.setAttribute("aria-atomic", "true");

      liveRegion.style.position = "absolute";
      liveRegion.style.width = "1px";
      liveRegion.style.height = "1px";
      liveRegion.style.padding = "0";
      liveRegion.style.margin = "-1px";
      liveRegion.style.overflow = "hidden";
      liveRegion.style.clip = "rect(0, 0, 0, 0)";
      liveRegion.style.whiteSpace = "nowrap";
      liveRegion.style.border = "0";

      assortmentRoot.appendChild(liveRegion);
    }

    liveRegion.textContent = "";

    window.setTimeout(function () {
      liveRegion.textContent = message;
    }, 50);
  }

function refreshAssortmentButtonLabels() {
  const label = state.sizeChosen
    ? "Add To My Assortment"
    : "Create My Assortment";

  addButtons.forEach(function (button) {
    if (!button.classList.contains("is-added")) {
      button.textContent = label;
    }
  });
}

refreshAssortmentButtonLabels();


  /* ==========================================
   SIZE SELECTION
========================================== */

function setAssortmentSize(nextSelection, source) {
  const normalizedSelection =
    normalizeText(nextSelection);

  const requestedSize =
    Number(nextSelection);

  const availableDefinitions =
    getAvailableAssortmentDefinitions();

  const definition =
    availableDefinitions.find(
      function (availableDefinition) {
        return (
          normalizedSelection &&
          availableDefinition.id ===
            normalizedSelection
        );
      }
    ) ||
    availableDefinitions.find(
      function (availableDefinition) {
        return (
          availableDefinition.size ===
          requestedSize
        );
      }
    ) ||
    null;

  const size = definition
    ? definition.size
    : requestedSize;

  /*
    The requested assortment either does not exist
    or is not available for this shipping tier.
  */

  if (!definition) {
    announce(
      "That assortment is not available for your delivery area."
    );

    return;
  }

  const usedSelections = getUsedSelections();

  if (usedSelections > definition.size) {
    announce(
      "Remove " +
        (usedSelections - definition.size) +
        " selections before changing to the " +
        definition.size +
        " count assortment."
    );

    return;
  }

  const previousSize = state.size;
  const previousAssortmentId =
    state.assortmentId || "";

  state.assortmentId = definition.id;
  state.assortmentName = definition.name;
  state.size = definition.size;
  state.sizeChosen = true;
  state.variantId = definition.variantId;
  state.title = definition.name;
  state.price = definition.price;
  state.savingsPercent =
    definition.savingsPercent;
  state.badge = definition.badge;
  state.productLine = definition.productLine;
  state.market = definition.market;
  state.ready =
    usedSelections === definition.size;

  /*
    Keep the visible assortment buttons synchronized.
  */

  sizeButtons.forEach(function (button) {
    const buttonAssortmentId =
      button.dataset.assortmentId || "";

    const isSelected = buttonAssortmentId
      ? buttonAssortmentId === definition.id
      : Number(button.dataset.assortmentSize) ===
        definition.size;

    button.classList.toggle(
      "is-active",
      isSelected
    );

    button.setAttribute(
      "aria-pressed",
      isSelected ? "true" : "false"
    );
  });

  renderAssortment();

  refreshAssortmentButtonLabels();

  if (
    previousAssortmentId !== definition.id ||
    previousSize !== definition.size
  ) {
    emitEvent("assortment:size_selected", {
      source: source || "size_selector",
      previousSize: previousSize,
      previousAssortmentId:
        previousAssortmentId,
      assortmentId: definition.id,
      assortmentName: definition.name,
      assortmentSize: definition.size,
      variantId: definition.variantId,
      price: definition.price,
      savingsPercent:
        definition.savingsPercent,
      badge: definition.badge,
      productLine: definition.productLine,
      market: definition.market,
      shippingTier:
        getEffectiveShippingTier()
    });
  }
}

  /* ==========================================
     ADD ITEM
  ========================================== */

  function getProductData(button) {
    const card = button.closest(
      "[data-category]"
    );

    const title =
      normalizeText(button.dataset.assortmentProduct) ||
      normalizeText(card && card.dataset.title) ||
      normalizeText(
        card &&
        card.querySelector(
          ".pss-concierge-product__title"
        ) &&
        card.querySelector(
          ".pss-concierge-product__title"
        ).textContent
      );

    const category =
      normalizeCategory(button.dataset.assortmentCategory) ||
      normalizeCategory(card && card.dataset.category) ||
      "dessert";

    const selections = Math.max(
      Number(button.dataset.assortmentSelections) || 1,
      1
    );

    return {
      key: createItemKey(category, title),
      title: title,
      category: category,
      selections: selections
    };
  }

  function addAssortmentItem(button) {
    const product = getProductData(button);

    if (!product.title) {
      console.warn(
        "[DH Commerce] Assortment product title is missing."
      );

      return;
    }

    const usedSelections = getUsedSelections();

    if (
      usedSelections + product.selections >
      state.size
    ) {
      const remaining = getRemainingSelections();

      announce(
        remaining === 0
          ? "Your assortment is already complete."
          : "Only " +
            remaining +
            " selections remain in this assortment."
      );

      assortmentSection.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });

      return;
    }

    const existingItem = state.items.find(function (item) {
      return item.key === product.key;
    });

    if (existingItem) {
      existingItem.quantity += 1;
    } else {
      state.items.push({
        key: product.key,
        title: product.title,
        category: product.category,
        selections: product.selections,
        quantity: 1
      });
    }

    if (!assortmentStarted) {
      assortmentStarted = true;

      emitEvent("assortment:started", {
        source: "commerce_product_card"
      });
    }


renderAssortment();

const completedSelections = getUsedSelections();

if (completedSelections === state.size) {
  window.setTimeout(function () {
    assortmentSection.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  }, 150);
}

    button.classList.add("is-added");
button.textContent = "✓ Added";
button.disabled = true;

window.setTimeout(function () {
  button.classList.remove("is-added");
  refreshAssortmentButtonLabels();
  button.disabled = false;
}, 350);

    announce(
      product.title +
      " added. " +
      getUsedSelections() +
      " of " +
      state.size +
      " selections filled."
    );

    emitEvent("assortment:item_added", {
      source: "commerce_product_card",
      product: product.title,
      category: product.category,
      selectionsAdded: product.selections
    });
  }


  /* ==========================================
     REMOVE ITEM
  ========================================== */

  function removeAssortmentItem(itemKey) {
    const item = state.items.find(function (candidate) {
      return candidate.key === itemKey;
    });

    if (!item) {
      return;
    }

    const removedTitle = item.title;
    const removedCategory = item.category;

    if (item.quantity > 1) {
      item.quantity -= 1;
    } else {
      state.items = state.items.filter(function (candidate) {
        return candidate.key !== itemKey;
      });
    }

    renderAssortment();


announce(
  removedTitle +
  " removed. " +
  getUsedSelections() +
  " of " +
  state.size +
  " selections filled."
);

    emitEvent("assortment:item_removed", {
      source: "assortment_summary",
      product: removedTitle,
      category: removedCategory
    });
  }


  /* ==========================================
     RENDER
  ========================================== */

  function renderAssortmentItems() {
    if (!state.items.length) {
      assortmentItems.innerHTML =
        '<p class="pss-assortment__empty">' +
          "Your assortment is empty." +
        "</p>";

      return;
    }

    assortmentItems.innerHTML = state.items
      .map(function (item) {
        const totalSelections =
          (Number(item.selections) || 1) *
          (Number(item.quantity) || 1);

        const quantityLabel =
          item.quantity > 1
            ? " ×" + item.quantity
            : "";

        const selectionLabel =
          totalSelections === 1
            ? "1 selection"
            : totalSelections + " selections";

        return (
          '<div class="pss-assortment__item">' +

            '<div class="pss-assortment__item-info">' +

              '<span class="pss-assortment__item-title">' +
                escapeHtml(item.title) +
                '<span class="pss-assortment__item-quantity">' +
                  escapeHtml(quantityLabel) +
                "</span>" +
              "</span>" +

              '<span class="pss-assortment__item-meta">' +
                escapeHtml(item.category) +
                " · " +
                escapeHtml(selectionLabel) +
              "</span>" +

            "</div>" +

            '<button ' +
              'type="button" ' +
              'class="pss-assortment__remove" ' +
              'data-assortment-remove="' +
                escapeHtml(item.key) +
              '" ' +
              'aria-label="Remove one ' +
                escapeHtml(item.title) +
                '">' +
              "Remove" +
            "</button>" +

          "</div>"
        );
      })
      .join("");
  }

  function isAssortmentBuilderInView() {
  if (!assortmentSection) {
    return false;
  }

  const rect =
    assortmentSection.getBoundingClientRect();

  return (
    rect.top < window.innerHeight * 0.85 &&
    rect.bottom > window.innerHeight * 0.15
  );
}

function updateAssortmentTrackerVisibility() {
  if (!assortmentTracker) {
    return;
  }

  assortmentTracker.hidden =
    getUsedSelections() === 0 ||
    isAssortmentBuilderInView();
}

function renderAssortment() {
  const usedSelections =
    getUsedSelections();

  assortmentSection.hidden =
    state.items.length === 0;

  /*
    Dataset values arrive as strings, so normalize
    the selected assortment size before comparing.
  */
  const assortmentSize =
    Number(state.size) || 0;

  const percentage =
    assortmentSize > 0
      ? Math.min(
          (usedSelections / assortmentSize) * 100,
          100
        )
      : 0;

  state.ready =
    assortmentSize > 0 &&
    usedSelections === assortmentSize &&
    state.items.length > 0;

  assortmentCount.textContent =
    usedSelections +
    " / " +
    assortmentSize +
    " Selected";

  assortmentProgress.style.width =
    percentage + "%";

  /*
    Update the compact sticky tracker.
  */
  if (
    assortmentTracker &&
    assortmentTrackerCount &&
    assortmentTrackerProgress &&
    assortmentTrackerView
  ) {
    assortmentTrackerCount.textContent =
      state.ready
        ? usedSelections +
          " of " +
          assortmentSize +
          " complete"
        : usedSelections +
          " of " +
          assortmentSize +
          " selected";

    assortmentTrackerProgress.style.width =
      percentage + "%";

    assortmentTrackerView.textContent =
      state.ready
        ? "Review Assortment"
        : "View My Assortment";

    assortmentTracker.classList.toggle(
      "is-complete",
      state.ready
    );

    updateAssortmentTrackerVisibility();
  }

  assortmentProgress.setAttribute(
    "aria-valuemin",
    "0"
  );

  assortmentProgress.setAttribute(
    "aria-valuemax",
    String(assortmentSize)
  );

  assortmentProgress.setAttribute(
    "aria-valuenow",
    String(usedSelections)
  );

  sizeButtons.forEach(function (button) {
    const buttonAssortmentId =
      button.dataset.assortmentId || "";

    const buttonSize =
      Number(
        button.dataset.assortmentSize
      ) || 0;

    const isSelected =
      state.assortmentId &&
      buttonAssortmentId
        ? buttonAssortmentId ===
          state.assortmentId
        : buttonSize === assortmentSize;

    button.classList.toggle(
      "is-active",
      isSelected
    );

    button.setAttribute(
      "aria-pressed",
      isSelected ? "true" : "false"
    );

    const buttonMarket =
      button.dataset.assortmentMarket ||
      "everyone";

    const buttonIsAvailable =
      isAssortmentMarketAvailable(
        buttonMarket,
        getEffectiveShippingTier()
      );

    button.disabled =
      !buttonIsAvailable ||
      buttonSize < usedSelections;
  });

  renderAssortmentItems();
  refreshAssortmentProductVisibility();
  refreshAssortmentButtonLabels();

  if (state.ready) {
    assortmentCheckout.disabled = false;

    assortmentCheckout.classList.add(
      "is-ready"
    );

    assortmentCheckout.textContent =
      "Add Assortment To Cart";

    if (!readyEventWasSent) {
      readyEventWasSent = true;

      emitEvent("assortment:ready", {
        source: "assortment_summary"
      });
    }
  } else {
    assortmentCheckout.disabled = true;

    assortmentCheckout.classList.remove(
      "is-ready"
    );

    const remaining =
      Math.max(
        assortmentSize - usedSelections,
        0
      );

    assortmentCheckout.textContent =
      remaining === 1
        ? "Choose 1 More Dessert"
        : "Choose " +
          remaining +
          " More Desserts";

    readyEventWasSent = false;
  }
}

if (
  assortmentSection &&
  !assortmentSection.dataset
    .assortmentTrackerVisibilityBound
) {
  assortmentSection.dataset
    .assortmentTrackerVisibilityBound =
    "true";

  window.addEventListener(
    "scroll",
    updateAssortmentTrackerVisibility,
    {
      passive: true
    }
  );

  window.addEventListener(
    "resize",
    updateAssortmentTrackerVisibility
  );
}

  /* ==========================================
     SHOPIFY CHECKOUT
  ========================================== */

  function createSelectionSummary() {
    return state.items
      .map(function (item) {
        return (
          item.title +
          " ×" +
          item.quantity
        );
      })
      .join(", ");
  }

  async function submitAssortment() {
    const usedSelections = getUsedSelections();

    if (
      !state.ready ||
      usedSelections !== (Number(state.size) || 0)
    ) {
      renderAssortment();

      return;
    }

   const selectedDefinition =
  getAvailableAssortmentDefinitions().find(
    function (definition) {
      if (
        state.assortmentId &&
        definition.id === state.assortmentId
      ) {
        return true;
      }

      return (
        !state.assortmentId &&
        state.variantId &&
        definition.variantId ===
          String(state.variantId)
      );
    }
  ) || null;

if (!selectedDefinition) {
  console.error(
    "[DH Commerce] The selected assortment definition is unavailable."
  );

  assortmentCheckout.textContent =
    "Choose An Available Assortment";

  announce(
    "This assortment is no longer available for your delivery area. Please choose another option."
  );

  state.ready = false;

  return;
}

/*
  Refresh the state from the selected definition immediately
  before sending the assortment to Shopify.
*/

state.assortmentId =
  selectedDefinition.id;

state.assortmentName =
  selectedDefinition.name;

state.size =
  selectedDefinition.size;

state.variantId =
  selectedDefinition.variantId;

state.title =
  selectedDefinition.name;

state.price =
  selectedDefinition.price;

state.savingsPercent =
  selectedDefinition.savingsPercent;

state.badge =
  selectedDefinition.badge;

state.productLine =
  selectedDefinition.productLine;

state.market =
  selectedDefinition.market;

if (!state.variantId) {
  console.error(
    "[DH Commerce] No Shopify variant ID is assigned for assortment " +
      selectedDefinition.id +
      "."
  );

  assortmentCheckout.textContent =
    "Variant ID Needed";

  announce(
    "The Shopify assortment variant has not been configured."
  );

  return;
}
 

    const originalText =
      assortmentCheckout.textContent;

    assortmentCheckout.disabled = true;
    assortmentCheckout.textContent =
      "Adding Assortment...";

    const giftNote = assortmentGift
      ? normalizeText(assortmentGift.value)
      : "";

    state.giftNote = giftNote;

    const properties = {
      "Assortment Type": state.title,
      "Selections Used": String(usedSelections),
      "Selections": createSelectionSummary()
    };

    if (giftNote) {
      properties["Gift Note"] = giftNote;
    }

    try {
      const response = await fetch(
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root + "cart/add.js"
          : "/cart/add.js",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(state.variantId),
                quantity: 1,
                properties: properties
              }
            ]
          })
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          "The assortment could not be added."
        );
      }

      assortmentCheckout.classList.add("is-added");
      assortmentCheckout.textContent =
        "Assortment Added";

      emitEvent("assortment:added_to_cart", {
        source: "assortment_summary",
        giftNotePresent: Boolean(giftNote)
      });

      window.setTimeout(function () {
        window.location.href =
          window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
            ? window.Shopify.routes.root + "cart"
            : "/cart";
      }, 450);

    } catch (error) {
      console.error(
        "[DH Commerce] Assortment checkout failed:",
        error
      );

      assortmentCheckout.disabled = false;
      assortmentCheckout.classList.remove("is-added");
      assortmentCheckout.textContent =
        originalText;

      announce(
        error.message ||
        "The assortment could not be added. Please try again."
      );
    }
  }


  /* ==========================================
   EVENT LISTENERS
========================================== */

if (assortmentTrackerView) {
  assortmentTrackerView.addEventListener(
    "click",
    function () {
      /*
        The full assortment may be inside the post-start
        reveal wrapper, so make sure it is visible.
      */

      document
        .querySelectorAll(".dh-commerce-after-start")
        .forEach(function (element) {
          element.classList.add("is-visible");
        });

      assortmentSection.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  );
}

/*
  Existing assortment size controls
*/

sizeButtons.forEach(function (button) {
  button.addEventListener("click", function () {
    setAssortmentSize(
      button.dataset.assortmentId ||
        button.dataset.assortmentSize,
      "assortment_launcher"
    );
  });
});

/*
  First-add assortment size chooser
*/

assortmentChooserOptions.forEach(function (option) {
  option.addEventListener("click", function () {
    if (option.hidden || option.disabled) {
      return;
    }

    const selectedAssortmentId =
      option.dataset.assortmentId || "";

    const selectedDefinition =
      getAvailableAssortmentDefinitions().find(
        function (definition) {
          return (
            definition.id === selectedAssortmentId
          );
        }
      ) || null;

    if (!selectedDefinition) {
      console.warn(
        "[DH Commerce] The selected assortment definition is missing or unavailable."
      );

      return;
    }

    /*
      Save the original dessert button before
      the chooser closes.
    */

    const originalAddButton =
      pendingAssortmentButton;

    /*
      Update the complete shared assortment state
      from the exact selected definition.
    */

    state.assortmentId =
      selectedDefinition.id;

    state.assortmentName =
      selectedDefinition.name;

    state.size =
      selectedDefinition.size;

    state.sizeChosen = true;

    state.variantId =
      selectedDefinition.variantId;

    state.title =
      selectedDefinition.name;

    state.price =
      selectedDefinition.price;

    state.savingsPercent =
      selectedDefinition.savingsPercent;

    state.badge =
      selectedDefinition.badge;

    state.productLine =
      selectedDefinition.productLine;

    state.market =
      selectedDefinition.market;

    state.ready =
      getUsedSelections() ===
      selectedDefinition.size;

    readyEventWasSent = state.ready;

    /*
      Synchronize the permanent assortment controls
      using the assortment ID.
    */

    sizeButtons.forEach(function (sizeButton) {
      const buttonAssortmentId =
        sizeButton.dataset.assortmentId || "";

      const isSelected =
        buttonAssortmentId ===
        selectedDefinition.id;

      sizeButton.classList.toggle(
        "is-active",
        isSelected
      );

      sizeButton.setAttribute(
        "aria-pressed",
        isSelected ? "true" : "false"
      );
    });

    closeAssortmentChooser();

    /*
      Add the dessert that originally opened
      the chooser.
    */

    if (originalAddButton) {
      addAssortmentItem(originalAddButton);
    }

    renderAssortment();
    refreshAssortmentButtonLabels();

    emitEvent("assortment:size_selected", {
      source: "first_add_chooser",
      assortmentId:
        selectedDefinition.id,
      assortmentName:
        selectedDefinition.name,
      assortmentSize:
        selectedDefinition.size,
      variantId:
        selectedDefinition.variantId,
      price:
        selectedDefinition.price,
      savingsPercent:
        selectedDefinition.savingsPercent,
      badge:
        selectedDefinition.badge,
      productLine:
        selectedDefinition.productLine,
      market:
        selectedDefinition.market,
      shippingTier:
        getEffectiveShippingTier()
    });
  });
});

/*
  Product-card assortment buttons
*/

addButtons.forEach(function (button) {
  button.addEventListener("click", function () {
    /*
      First assortment click opens the size chooser.
    */

    if (!state.sizeChosen) {
      openAssortmentChooser(button);
      return;
    }

    /*
      Later clicks add immediately.
    */

    addAssortmentItem(button);
  });
});

/*
  Remove assortment items
*/

assortmentItems.addEventListener(
  "click",
  function (event) {
    const removeButton = event.target.closest(
      "[data-assortment-remove]"
    );

    if (!removeButton) {
      return;
    }

    removeAssortmentItem(
      removeButton.dataset.assortmentRemove
    );
  }
);

/*
  Gift message
*/

if (assortmentGift) {
  assortmentGift.value = state.giftNote;

  assortmentGift.addEventListener(
    "input",
    function () {
      state.giftNote = assortmentGift.value;
    }
  );
}

/*
  Assortment checkout
*/

assortmentCheckout.addEventListener(
  "click",
  submitAssortment
);

/* ==========================================
   PUBLIC DH COMMERCE METHODS
========================================== */

DHCommerce.assortment = {
  getState: function () {
    return state;
  },

  getUsedSelections: getUsedSelections,

  getRemainingSelections: getRemainingSelections,

  setSize: function (size) {
    setAssortmentSize(
      size,
      "dhcommerce_api"
    );
  },

  addItem: function (item) {
    if (!item || !item.title) {
      return;
    }

    const temporaryButton =
      document.createElement("button");

    temporaryButton.dataset.assortmentProduct =
      item.title;

    temporaryButton.dataset.assortmentCategory =
      item.category || "dessert";

    temporaryButton.dataset.assortmentSelections =
      String(item.selections || 1);

    addAssortmentItem(temporaryButton);
  },

  removeItem: removeAssortmentItem,

  render: renderAssortment
};


/*
  Keep assortment availability synchronized whenever
  the regional shipping resolver changes the active tier.
*/

document.addEventListener(
  "dhcommerce",
  function (event) {
    const commerceEvent =
      event && event.detail
        ? event.detail
        : null;

    if (
      !commerceEvent ||
      (
        commerceEvent.name !==
          "shipping:tier" &&
        commerceEvent.name !==
          "shipping:ready"
      )
    ) {
      return;
    }

    refreshAssortmentChooserOptions();
    refreshAssortmentSizeButtons();

    const availableDefinitions =
      getAvailableAssortmentDefinitions();

    const currentDefinition =
      availableDefinitions.find(
        function (definition) {
          if (
            state.assortmentId &&
            definition.id ===
              state.assortmentId
          ) {
            return true;
          }

          if (
            state.variantId &&
            definition.variantId ===
              String(state.variantId)
          ) {
            return true;
          }

          return (
            !state.assortmentId &&
            !state.variantId &&
            definition.size ===
              Number(state.size)
          );
        }
      ) || null;

    /*
      If the currently selected definition is still
      available for the new shipping tier, nothing
      needs to change.
    */

    if (currentDefinition) {
      return;
    }

    const fallbackDefinition =
      getDefaultAssortmentDefinition();

    if (!fallbackDefinition) {
      state.assortmentId = "";
      state.assortmentName = "";
      state.size = 0;
      state.variantId = "";
      state.title = "";
      state.price = "";
      state.savingsPercent = 0;
      state.badge = "";
      state.productLine = "";
      state.market = "everyone";
      state.ready = false;

      renderAssortment();

      announce(
        "No assortment options are currently " +
        "available for your delivery area."
      );

      return;
    }

    const usedSelections =
      getUsedSelections();

    /*
      Do not silently move an in-progress assortment
      into a fallback that is too small for its
      existing selections.
    */

    if (
      usedSelections >
      fallbackDefinition.size
    ) {
      state.ready = false;

      renderAssortment();

      announce(
        "Your selected assortment is no longer " +
        "available for this delivery area. " +
        "Remove selections or choose another " +
        "available size."
      );

      return;
    }

    state.assortmentId =
      fallbackDefinition.id;

    state.assortmentName =
      fallbackDefinition.name;

    state.size =
      fallbackDefinition.size;

    state.variantId =
      fallbackDefinition.variantId;

    state.title =
      fallbackDefinition.name;

    state.price =
      fallbackDefinition.price;

    state.savingsPercent =
      fallbackDefinition.savingsPercent;

    state.badge =
      fallbackDefinition.badge;

    state.productLine =
      fallbackDefinition.productLine;

    state.market =
      fallbackDefinition.market;

    state.ready =
      usedSelections ===
      fallbackDefinition.size;

    renderAssortment();
    refreshAssortmentButtonLabels();

    announce(
      "Your assortment was updated to an " +
      "option available for your delivery area."
    );
  }
);

/* ==========================================
   INITIALIZE
========================================== */

refreshAssortmentChooserOptions();
refreshAssortmentSizeButtons();

renderAssortment();
 

console.info(
  "[DH Commerce] Shared assortment initialized.",
  {
    size: state.size,
    sizeChosen: state.sizeChosen,
    variantId: state.variantId,
    shippingTier: getShippingTier()
  }
);

})();

/*
  Mobile header Shop dropdown
*/

const headerDropdown = document.querySelector(
  ".pss-home .pss-header-dropdown"
);

if (headerDropdown) {
  const headerDropdownTrigger =
    headerDropdown.querySelector(
      ".pss-header-dropdown__trigger"
    );

  const headerDropdownMenu =
    headerDropdown.querySelector(
      ".pss-header-dropdown__menu"
    );

  function closeHeaderDropdown() {
    headerDropdown.classList.remove("is-open");

    if (headerDropdownTrigger) {
      headerDropdownTrigger.setAttribute(
        "aria-expanded",
        "false"
      );

      headerDropdownTrigger.blur();
    }
  }

  if (headerDropdownTrigger && headerDropdownMenu) {
    headerDropdownTrigger.setAttribute(
      "aria-expanded",
      "false"
    );

    headerDropdownTrigger.addEventListener(
      "click",
      function (event) {
        /*
          On desktop, preserve the existing hover behavior.
        */

        if (
          !window.matchMedia(
            "(max-width: 749px)"
          ).matches
        ) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        const willOpen =
          !headerDropdown.classList.contains(
            "is-open"
          );

        headerDropdown.classList.toggle(
          "is-open",
          willOpen
        );

        headerDropdownTrigger.setAttribute(
          "aria-expanded",
          willOpen ? "true" : "false"
        );
      }
    );

    headerDropdownMenu
      .querySelectorAll("a")
      .forEach(function (link) {
        link.addEventListener(
          "click",
          closeHeaderDropdown
        );
      });

    document.addEventListener(
      "click",
      function (event) {
        if (
          !headerDropdown.contains(event.target)
        ) {
          closeHeaderDropdown();
        }
      }
    );

    document.addEventListener(
      "keydown",
      function (event) {
        if (event.key === "Escape") {
          closeHeaderDropdown();
        }
      }
    );
  }
}